/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_setTagActiveRequest } from '../models/api_setTagActiveRequest';
import type { api_tagRequest } from '../models/api_tagRequest';
import type { db_DropdownTag } from '../models/db_DropdownTag';
import type { db_GetTagRow } from '../models/db_GetTagRow';
import type { db_ListTagsRow } from '../models/db_ListTagsRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class Tags {
    /**
     * List tags for the caller's programmes
     * @returns db_ListTagsRow OK
     * @throws ApiError
     */
    public static listTags(): CancelablePromise<Array<db_ListTagsRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/tags',
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create a tag
     * @param body Tag details
     * @returns db_DropdownTag Created
     * @throws ApiError
     */
    public static createTag(
        body: api_tagRequest,
    ): CancelablePromise<db_DropdownTag> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/tags',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a tag by ID
     * @param id Tag ID
     * @returns db_GetTagRow OK
     * @throws ApiError
     */
    public static getTag(
        id: number,
    ): CancelablePromise<db_GetTagRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/tags/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete a tag that is not assigned to any beneficiary
     * @param id Tag ID
     * @returns void
     * @throws ApiError
     */
    public static deleteTag(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/tags/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a tag
     * @param id Tag ID
     * @param body Tag details
     * @returns db_DropdownTag OK
     * @throws ApiError
     */
    public static updateTag(
        id: number,
        body: api_tagRequest,
    ): CancelablePromise<db_DropdownTag> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/tags/{id}',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Activate or deactivate a tag
     * @param id Tag ID
     * @param body Active status
     * @returns db_DropdownTag OK
     * @throws ApiError
     */
    public static setTagActive(
        id: number,
        body: api_setTagActiveRequest,
    ): CancelablePromise<db_DropdownTag> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/tags/{id}/active',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
